import { Link } from 'react-router-dom';
import { fixApiUrl } from '../api';

export default function ImageCard({ name, imageUrl, viewRel, downloadUrl }) {
  const displayName = typeof name === 'string' ? name.replace(/\.[^.]+$/, '') : name;
  return (
    <div className="image-card">
      <Link to={`/viewer?rel=${encodeURIComponent(viewRel)}`} className="image-card__media" aria-label={`View ${name}`}>
        <img src={fixApiUrl(imageUrl)} alt={name} loading="lazy" decoding="async" />
      </Link>
      <div className="image-card__name" title={displayName}>{displayName}</div>
      <div className="image-card__actions">
        <a className="btn-download" href={fixApiUrl(downloadUrl)}>Download</a>
      </div>
    </div>
  );
}

